const headerNavLinks = [
  { href: '/', title: 'Home' },
  { href: '/blog', title: 'Blog' },
  // { href: '/tags', title: 'Tags' },
  { href: '/reports', title: 'Reports' },
  { href: '/newsletter', title: 'Newsletter' },
  { href: '/about', title: 'About' },
  { href: '/authors', title: 'Editorial' },
  { href: '/livescores', title: 'Livescores' },
  { href: '/live', title: 'Mills' },
]

export default headerNavLinks
